export enum SapMessageType {
    error = 'E',
    warning = 'W',
}
